// AUTO-GENERATED GraphQL Builder for Booking
import * as Builders from '../';
export class BookingBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  bookingNo(){ return this.add('bookingNo'); }
  customerId(){ return this.add('customerId'); }
  resellerVendorId(){ return this.add('resellerVendorId'); }
  eventDate(){ return this.add('eventDate'); }
  eventTime(){ return this.add('eventTime'); }
  eventSessionId(){ return this.add('eventSessionId'); }
  venueName(){ return this.add('venueName'); }
  venueAddress(){ return this.add('venueAddress'); }
  totalAmount(){ return this.add('totalAmount'); }
  protectionFee(){ return this.add('protectionFee'); }
  depositPercent(){ return this.add('depositPercent'); }
  balanceDueDate(){ return this.add('balanceDueDate'); }
  isResale(){ return this.add('isResale'); }
  status(){ return this.add('status'); }
  notes(){ return this.add('notes'); }
  origin(){ return this.add('origin'); }
  guests(){ return this.add('guests'); }
  primaryOfferingId(){ return this.add('primaryOfferingId'); }
  holdExpiresOn(){ return this.add('holdExpiresOn'); }
  depositAmount(){ return this.add('depositAmount'); }
  protectionPct(){ return this.add('protectionPct'); }
  isInvoiceVoid(){ return this.add('isInvoiceVoid'); }
  completionStatus(){ return this.add('completionStatus'); }
  completionRequestedDate(){ return this.add('completionRequestedDate'); }
  requestedDate(){ return this.add('requestedDate'); }
  completionDecidedDate(){ return this.add('completionDecidedDate'); }
  contactName(){ return this.add('contactName'); }
  contactPhone(){ return this.add('contactPhone'); }
  contactEmail(){ return this.add('contactEmail'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  customer(b?:(q:Builders.CustomerBuilder)=>void){
    if(this.depth>=5||this.v.has('customer'))return this;
    this.v.add('customer');
    const n=new Builders.CustomerBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`customer { ${inner} }`);
    return this;
  }

  eventSession(b?:(q:Builders.EventSessionBuilder)=>void){
    if(this.depth>=5||this.v.has('eventSession'))return this;
    this.v.add('eventSession');
    const n=new Builders.EventSessionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`eventSession { ${inner} }`);
    return this;
  }

  primaryOffering(b?:(q:Builders.OfferingBuilder)=>void){
    if(this.depth>=5||this.v.has('primaryOffering'))return this;
    this.v.add('primaryOffering');
    const n=new Builders.OfferingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`primaryOffering { ${inner} }`);
    return this;
  }

  resellerVendor(b?:(q:Builders.VendorBuilder)=>void){
    if(this.depth>=5||this.v.has('resellerVendor'))return this;
    this.v.add('resellerVendor');
    const n=new Builders.VendorBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`resellerVendor { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }

  bookingAdjustmentList(b?:(q:Builders.BookingAdjustmentBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingAdjustmentList'))return this;
    this.v.add('bookingAdjustmentList');
    const n=new Builders.BookingAdjustmentBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingAdjustmentList { ${inner} }`);
    return this;
  }

  bookingCancellationList(b?:(q:Builders.BookingCancellationBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingCancellationList'))return this;
    this.v.add('bookingCancellationList');
    const n=new Builders.BookingCancellationBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingCancellationList { ${inner} }`);
    return this;
  }

  bookingChangeProposalList(b?:(q:Builders.BookingChangeProposalBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingChangeProposalList'))return this;
    this.v.add('bookingChangeProposalList');
    const n=new Builders.BookingChangeProposalBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingChangeProposalList { ${inner} }`);
    return this;
  }

  bookingCompletionProofList(b?:(q:Builders.BookingCompletionProofBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingCompletionProofList'))return this;
    this.v.add('bookingCompletionProofList');
    const n=new Builders.BookingCompletionProofBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingCompletionProofList { ${inner} }`);
    return this;
  }

  bookingDishSelectionList(b?:(q:Builders.BookingDishSelectionBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingDishSelectionList'))return this;
    this.v.add('bookingDishSelectionList');
    const n=new Builders.BookingDishSelectionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingDishSelectionList { ${inner} }`);
    return this;
  }

  bookingDisputeList(b?:(q:Builders.BookingDisputeBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingDisputeList'))return this;
    this.v.add('bookingDisputeList');
    const n=new Builders.BookingDisputeBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingDisputeList { ${inner} }`);
    return this;
  }

  bookingFeeRateList(b?:(q:Builders.BookingFeeRateBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingFeeRateList'))return this;
    this.v.add('bookingFeeRateList');
    const n=new Builders.BookingFeeRateBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingFeeRateList { ${inner} }`);
    return this;
  }

  bookingItemSelectionList(b?:(q:Builders.BookingItemSelectionBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingItemSelectionList'))return this;
    this.v.add('bookingItemSelectionList');
    const n=new Builders.BookingItemSelectionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingItemSelectionList { ${inner} }`);
    return this;
  }

  bookingMilestoneList(b?:(q:Builders.BookingMilestoneBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingMilestoneList'))return this;
    this.v.add('bookingMilestoneList');
    const n=new Builders.BookingMilestoneBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingMilestoneList { ${inner} }`);
    return this;
  }

  bookingPackageList(b?:(q:Builders.BookingPackageBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingPackageList'))return this;
    this.v.add('bookingPackageList');
    const n=new Builders.BookingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackageList { ${inner} }`);
    return this;
  }

  bookingPartnerChangeList(b?:(q:Builders.BookingPartnerChangeBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingPartnerChangeList'))return this;
    this.v.add('bookingPartnerChangeList');
    const n=new Builders.BookingPartnerChangeBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPartnerChangeList { ${inner} }`);
    return this;
  }

  bookingScheduleList(b?:(q:Builders.BookingScheduleBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingScheduleList'))return this;
    this.v.add('bookingScheduleList');
    const n=new Builders.BookingScheduleBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingScheduleList { ${inner} }`);
    return this;
  }

  bookingSlotSelectionList(b?:(q:Builders.BookingSlotSelectionBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingSlotSelectionList'))return this;
    this.v.add('bookingSlotSelectionList');
    const n=new Builders.BookingSlotSelectionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingSlotSelectionList { ${inner} }`);
    return this;
  }

  earlyReleaseList(b?:(q:Builders.EarlyReleaseBuilder)=>void){
    if(this.depth>=5||this.v.has('earlyReleaseList'))return this;
    this.v.add('earlyReleaseList');
    const n=new Builders.EarlyReleaseBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`earlyReleaseList { ${inner} }`);
    return this;
  }

  invoiceList(b?:(q:Builders.InvoiceBuilder)=>void){
    if(this.depth>=5||this.v.has('invoiceList'))return this;
    this.v.add('invoiceList');
    const n=new Builders.InvoiceBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`invoiceList { ${inner} }`);
    return this;
  }

  ledgerEntryList(b?:(q:Builders.LedgerEntryBuilder)=>void){
    if(this.depth>=5||this.v.has('ledgerEntryList'))return this;
    this.v.add('ledgerEntryList');
    const n=new Builders.LedgerEntryBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`ledgerEntryList { ${inner} }`);
    return this;
  }

  notificationList(b?:(q:Builders.NotificationBuilder)=>void){
    if(this.depth>=5||this.v.has('notificationList'))return this;
    this.v.add('notificationList');
    const n=new Builders.NotificationBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`notificationList { ${inner} }`);
    return this;
  }

  partnerApprovalList(b?:(q:Builders.PartnerApprovalBuilder)=>void){
    if(this.depth>=5||this.v.has('partnerApprovalList'))return this;
    this.v.add('partnerApprovalList');
    const n=new Builders.PartnerApprovalBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`partnerApprovalList { ${inner} }`);
    return this;
  }

  paymentList(b?:(q:Builders.PaymentBuilder)=>void){
    if(this.depth>=5||this.v.has('paymentList'))return this;
    this.v.add('paymentList');
    const n=new Builders.PaymentBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`paymentList { ${inner} }`);
    return this;
  }

  reviewList(b?:(q:Builders.ReviewBuilder)=>void){
    if(this.depth>=5||this.v.has('reviewList'))return this;
    this.v.add('reviewList');
    const n=new Builders.ReviewBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`reviewList { ${inner} }`);
    return this;
  }

  weddingCardList(b?:(q:Builders.WeddingCardBuilder)=>void){
    if(this.depth>=5||this.v.has('weddingCardList'))return this;
    this.v.add('weddingCardList');
    const n=new Builders.WeddingCardBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`weddingCardList { ${inner} }`);
    return this;
  }

  reverseBookingAdjustment(b?:(q:Builders.BookingAdjustmentBuilder)=>void){
    const n=new Builders.BookingAdjustmentBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingAdjustmentList { ${inner} }`);
    return this;
  }

  reverseBookingCancellation(b?:(q:Builders.BookingCancellationBuilder)=>void){
    const n=new Builders.BookingCancellationBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingCancellationList { ${inner} }`);
    return this;
  }

  reverseBookingChangeProposal(b?:(q:Builders.BookingChangeProposalBuilder)=>void){
    const n=new Builders.BookingChangeProposalBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingChangeProposalList { ${inner} }`);
    return this;
  }

  reverseBookingCompletionProof(b?:(q:Builders.BookingCompletionProofBuilder)=>void){
    const n=new Builders.BookingCompletionProofBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingCompletionProofList { ${inner} }`);
    return this;
  }

  reverseBookingDishSelection(b?:(q:Builders.BookingDishSelectionBuilder)=>void){
    const n=new Builders.BookingDishSelectionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingDishSelectionList { ${inner} }`);
    return this;
  }

  reverseBookingDispute(b?:(q:Builders.BookingDisputeBuilder)=>void){
    const n=new Builders.BookingDisputeBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingDisputeList { ${inner} }`);
    return this;
  }

  reverseBookingFeeRate(b?:(q:Builders.BookingFeeRateBuilder)=>void){
    const n=new Builders.BookingFeeRateBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingFeeRateList { ${inner} }`);
    return this;
  }

  reverseBookingItemSelection(b?:(q:Builders.BookingItemSelectionBuilder)=>void){
    const n=new Builders.BookingItemSelectionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingItemSelectionList { ${inner} }`);
    return this;
  }

  reverseBookingMilestone(b?:(q:Builders.BookingMilestoneBuilder)=>void){
    const n=new Builders.BookingMilestoneBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingMilestoneList { ${inner} }`);
    return this;
  }

  reverseBookingPackage(b?:(q:Builders.BookingPackageBuilder)=>void){
    const n=new Builders.BookingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackageList { ${inner} }`);
    return this;
  }

  reverseBookingPartnerChange(b?:(q:Builders.BookingPartnerChangeBuilder)=>void){
    const n=new Builders.BookingPartnerChangeBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPartnerChangeList { ${inner} }`);
    return this;
  }

  reverseBookingSchedule(b?:(q:Builders.BookingScheduleBuilder)=>void){
    const n=new Builders.BookingScheduleBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingScheduleList { ${inner} }`);
    return this;
  }

  reverseBookingSlotSelection(b?:(q:Builders.BookingSlotSelectionBuilder)=>void){
    const n=new Builders.BookingSlotSelectionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingSlotSelectionList { ${inner} }`);
    return this;
  }

  reverseEarlyRelease(b?:(q:Builders.EarlyReleaseBuilder)=>void){
    const n=new Builders.EarlyReleaseBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`earlyReleaseList { ${inner} }`);
    return this;
  }

  reverseHeldShareRebalanceResult(b?:(q:Builders.HeldShareRebalanceResultBuilder)=>void){
    const n=new Builders.HeldShareRebalanceResultBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`heldShareRebalanceResultList { ${inner} }`);
    return this;
  }

  reverseInvoice(b?:(q:Builders.InvoiceBuilder)=>void){
    const n=new Builders.InvoiceBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`invoiceList { ${inner} }`);
    return this;
  }

  reverseLedgerEntry(b?:(q:Builders.LedgerEntryBuilder)=>void){
    const n=new Builders.LedgerEntryBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`ledgerEntryList { ${inner} }`);
    return this;
  }

  reversePartnerApproval(b?:(q:Builders.PartnerApprovalBuilder)=>void){
    const n=new Builders.PartnerApprovalBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`partnerApprovalList { ${inner} }`);
    return this;
  }

  reversePaymentEvent(b?:(q:Builders.PaymentEventBuilder)=>void){
    const n=new Builders.PaymentEventBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`paymentEventList { ${inner} }`);
    return this;
  }

  reversePayment(b?:(q:Builders.PaymentBuilder)=>void){
    const n=new Builders.PaymentBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`paymentList { ${inner} }`);
    return this;
  }

  reversePaymentTransfer(b?:(q:Builders.PaymentTransferBuilder)=>void){
    const n=new Builders.PaymentTransferBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`paymentTransferList { ${inner} }`);
    return this;
  }

  reverseRefund(b?:(q:Builders.RefundBuilder)=>void){
    const n=new Builders.RefundBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`refundList { ${inner} }`);
    return this;
  }

  reverseReview(b?:(q:Builders.ReviewBuilder)=>void){
    const n=new Builders.ReviewBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`reviewList { ${inner} }`);
    return this;
  }

  reverseWeddingCard(b?:(q:Builders.WeddingCardBuilder)=>void){
    const n=new Builders.WeddingCardBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`weddingCardList { ${inner} }`);
    return this;
  }
}
